const contractGatesParamsActions = {
  CONTRACT_GATES_PARAMS_INIT: 'CONTRACT_GATES_PARAMS_INIT',
  CONTRACT_GATES_PARAMS_SET: 'CONTRACT_GATES_PARAMS_SET'
};
export default contractGatesParamsActions;
